import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import {createStore} from 'vuex-extensions'

import Root from './src/Root.vue'
import cdssStoreConfig from "../edith-cdss/src/vuex";
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAxios from "vue-axios";
import axios from "axios";
import router from "./src/router";
import state from "./src/vuex/state"
import getters from "./src/vuex/getters";

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueAxios, axios)


new Vue({
    store: createStore(Vuex.Store, {
        state: state,
        getters: getters,
        plugins: [],
        modules: {
            cdss: cdssStoreConfig,
        }
    }),
    router: router,
    render: h => h(Root),
}).$mount('#app')
